import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL, AUTH } from "../../../config/axios";
import { motion } from 'framer-motion';
import { Plus } from "lucide-react";
import { AddwithWhiteCircle } from "../../AllSvg";
import { Modal } from "react-bootstrap";
import Select, { components } from "react-select";
import { CSSForSelect, CSSForSelect15VW } from "../../CustomFunctions";
import { AddWithPlus } from "../../Buttons";

const Option = (props) => (
    <components.Option {...props}>

        <label title="Star" class="star">
            <input id="star-checkbox" checked={props.isSelected}
                onChange={() => null} className="checkbox" type="checkbox" />
            <div className="svg-container">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="svg-outline"
                    viewBox="0 0 24 24"
                >
                    <path
                        d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
                    ></path>
                </svg>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="svg-filled"
                    viewBox="0 0 24 24"
                >
                    <path
                        d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
                    ></path>
                </svg>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="100"
                    width="100"
                    className="svg-celebrate"
                >
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                    <circle r="2" cy="50" cx="50" className="particle"></circle>
                </svg>
            </div>
        </label>
        {props.label}
    </components.Option>
);



const MenuList = (props) => {
    const { options, selectProps } = props;

    const filteredOptions = options.filter(
        (opt) => opt.label.toLowerCase() !== "other"
    );

    const selectedValues = selectProps.value?.map((i) => i.value) || [];
    const filteredValues = filteredOptions.map((i) => i.value);

    const isAllSelected = filteredValues.every((val) =>
        selectedValues.includes(val)
    );

    const handleToggle = () => {
        if (isAllSelected) {
            const preserveOther = selectProps.value?.filter(
                (i) => i.label.toLowerCase() === "other"
            ) || [];
            selectProps.onChange(preserveOther);
        } else {
            const preserveOther = selectProps.value?.filter(
                (i) => i.label.toLowerCase() === "other"
            ) || [];
            selectProps.onChange([...filteredOptions, ...preserveOther]);
        }
    };

    return (
        <components.MenuList {...props}>
            <button
                onClick={handleToggle}
                style={{
                    width: "100%",
                    padding: "6px 0",
                    cursor: "pointer",
                    fontWeight: "600",
                    borderBottom: "1px solid #e3e3e3",
                    background: "white"
                }}
            >
                {isAllSelected ? "Unselect All" : "Select All"}
            </button>

            {props.children}
        </components.MenuList>
    );
};

const AddRailwayProject = ({ getProjectname, useFor }) => {
    const [errors, setErrors] = useState({});
    const [show, setShow] = useState(false);
    const [subCompany, setSubCompany] = useState([]);
    const [company, setCompany] = useState([]);
    const [companyData, setCompanyData] = useState("null");
    const [CostType, setCostType] = useState("null");
    const [croreInput, setCroreInput] = useState("");
    const [lakhInput, setLakhInput] = useState("");
    const [thousandInput, setThousandInput] = useState("");

    const [formData, setFormData] = useState({
        pr_code: '',
        project_name: '',
        division: 'null',
        department: "",
        project_post: "",
        basic_value: "",
        gst_amount: "0",
        total_amount: "",
        work_type_id: "",
        loa_date: "",
        total_length: "",
        completion_date: "",
        workstages: [],
        sector: "a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7",
        subcompany: "",
        project_short_name: "",
    });

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setFormData({
            pr_code: '',
            project_name: '',
            division: 'null',
            department: "",
            work_type_id: "",
            project_post: "",
            basic_value: "",
            gst_amount: "0",
            total_amount: "",

            loa_date: "",
            total_length: "",
            completion_date: "",
            workstages: [],
            sector: "a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7",
            subcompany: "",
            project_short_name: "",
        })

        setCostType("null");
        setCroreInput("");
        setLakhInput("");
        setThousandInput("");
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });
    };

    // GST box: only touches gst_amount and total_amount
    const handleGstChange = (e) => {
        const v = e.target.value;
        setFormData((p) => ({
            ...p,
            gst_amount: v,
            total_amount: Number(p.project_post || 0) + Number(v || 0),
        }));
    };

    const validateform = () => {
        const newErrors = {};
        const requiredFields = [
            "pr_code", "project_name", "division", "department", "subcompany",
            "work_type_id", "loa_date", "total_length", "completion_date",
            "workstages", "sector", "project_short_name", 'project_post'
        ];

        requiredFields.forEach((field) => {
            const value = formData[field];

            // for string values
            if (typeof value === "string" && value.trim() === "") {
                newErrors[field] = "This field is required!";
            }
            // for arrays (like workstages)
            else if (Array.isArray(value) && value.length === 0) {
                newErrors[field] = "This field is required!";
            }
            // for values that are null / undefined / "null"
            else if (value === null || value === undefined || value === "null") {
                newErrors[field] = "This field is required!";
            }

            if (CostType === "null") {
                newErrors['CostType'] = "This field is required!";
            }
            if (CostType === "crore_lakh_thousand") {
                if (croreInput.trim() === "") {
                    newErrors['croreInput'] = "This field is required!";
                }
                if (thousandInput.trim() === "") {
                    newErrors['thousandInput'] = "This field is required!";
                }
                if (lakhInput.trim() === "") {
                    newErrors['lakhInput'] = "This field is required!";
                }
            }
            else if (CostType === "crore_lakh") {
                if (croreInput.trim() === "") {
                    newErrors['croreInput'] = "This field is required!";
                }
                if (lakhInput.trim() === "") {
                    newErrors['lakhInput'] = "This field is required!";
                }
            }
            else if (CostType === "lakh_thousand") {
                if (lakhInput.trim() === "") {
                    newErrors['lakhInput'] = "This field is required!";
                }
                if (thousandInput.trim() === "") {
                    newErrors['thousandInput'] = "This field is required!";
                }
            }
            else if (CostType === "crore") {
                if (croreInput.trim() === "") {
                    newErrors['croreInput'] = "This field is required!";
                }
            }
            else if (CostType === "lakh") {
                if (lakhInput.trim() === "") {
                    newErrors['lakhInput'] = "This field is required!";
                }
            }
            else if (CostType === "thousand") {
                if (thousandInput.trim() === "") {
                    newErrors['thousandInput'] = "This field is required!";
                }
            }
        });


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateform()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const payload = {
                        ...formData,
                        basic_value: Number(formData.project_post || 0),
                        gst_amount: Number(formData.gst_amount || 0),
                        total_amount: Number(formData.project_post || 0) + Number(formData.gst_amount || 0),
                };
                const res = await axios.post(`${BASE_URL}/dpr/projectdetails/`, payload, AUTH());

                if (res.status === 201 || res.status === 200) {
                    toast.success("Project  added successfully!");
                    handleClose();
                    await getProjectname();
                }
            } catch (err) {
                console.error("Error adding project :", err);
                if (err.response?.data) {
                    toast.error(`Failed to add project : ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to add project ");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const fetchSubcompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/dpr/divisionfilterbysubcompany/${companyData}/`);
            setSubCompany(res.data);
        } catch (err) {
            console.error(err);
            toast.error("Failed to fetch sub company data.");
        }
    };

    useEffect(() => {
        if (companyData !== "null") {
            fetchSubcompany();

        }
    }, [companyData]);
    const fetchCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/dpr/subcompany/`);
            setCompany(res.data);
        } catch (err) {
            console.error(err);
            toast.error("Failed to fetch company data.");
        }
    };

    useEffect(() => {
        if (show === true) {
            fetchCompany();

        }
    }, [show]);
    const departmentListRailways = [
        { value: "Northern Railway (NR)", label: "Northern Railway (NR)" },
        { value: "Southern Railway (SR)", label: "Southern Railway (SR)" },
        { value: "Eastern Railway (ER)", label: "Eastern Railway (ER)" },
        { value: "Western Railway (WR)", label: "Western Railway (WR)" },
        { value: "Central Railway (CR)", label: "Central Railway (CR)" },
        { value: "North Central Railway (NCR)", label: "North Central Railway (NCR)" },
        { value: "South Central Railway (SCR)", label: "South Central Railway (SCR)" },
        { value: "East Central Railway (ECR)", label: "East Central Railway (ECR)" },
        { value: "West Central Railway (WCR)", label: "West Central Railway (WCR)" },
        { value: "North Western Railway (NWR)", label: "North Western Railway (NWR)" },
        { value: "North Eastern Railway (NER)", label: "North Eastern Railway (NER)" },
        { value: "North East Frontier Railway (NFR)", label: "North East Frontier Railway (NFR)" },
        { value: "South Eastern Railway (SER)", label: "South Eastern Railway (SER)" },
        { value: "South East Central Railway (SECR)", label: "South East Central Railway (SECR)" },
        { value: "South Western Railway (SWR)", label: "South Western Railway (SWR)" },
        { value: "East Coast Railway (ECoR)", label: "East Coast Railway (ECoR)" },
        { value: "South Coast Railway (SCoR)", label: "South Coast Railway (SCoR)" },
        { value: "Rail Vikas Nigam Limited (RVNL)", label: "Rail Vikas Nigam Limited (RVNL)" },
        { value: "RITES Ltd.", label: "RITES Ltd." },
        { value: "IRCON International Ltd.", label: "IRCON International Ltd." },
        { value: "Dedicated Freight Corridor Corporation (DFCCIL)", label: "Dedicated Freight Corridor Corporation (DFCCIL)" },
        { value: "RailTel Corporation of India", label: "RailTel Corporation of India" },
        { value: "Konkan Railway Corporation (KRCL)", label: "Konkan Railway Corporation (KRCL)" },
        { value: "Mumbai Railway Vikas Corporation (MRVC)", label: "Mumbai Railway Vikas Corporation (MRVC)" },
        { value: "Central Organisation for Railway Electrification (CORE)", label: "Central Organisation for Railway Electrification (CORE)" },
        { value: "Centre for Railway Information Systems (CRIS)", label: "Centre for Railway Information Systems (CRIS)" },
        { value: "Ministry of Railways", label: "Ministry of Railways" },
        { value: "Railway Energy Management Company Limited", label: "Railway Energy Management Company Limited" },
    ];



    const departListHighway = [
        { value: "NHAI", label: "NHAI" },
        { value: "MoRTH", label: "MoRTH" },
        { value: "NHIDCL", label: "NHIDCL" },
        { value: "BRO", label: "BRO" },
        { value: "PWDs", label: "PWDs" },
        { value: "MPRDCL", label: "MPRDCL" },
        { value: "BHDCL", label: "BHDCL" },
        { value: "HSIIDC", label: "HSIIDC" },
        { value: "SHAJ", label: "SHAJ" },
        { value: "GJRDCL", label: "GJRDCL" },
        { value: "MHRDCL", label: "MHRDCL" },
        { value: "MPRDCL", label: "MPRDCL" },
        { value: "UPEIDA", label: "UPEIDA" },
        { value: "UPHA&SP", label: "UPHA&SP" },
        { value: "RITES", label: "RITES" },
        { value: "APCRDA", label: "APCRDA" },
        { value: "RCDB", label: "RCDB" },
        { value: "BSIL", label: "BSIL" },
        { value: "BUIDCL", label: "BUIDCL" },
        { value: "CMRL", label: "CMRL" },
        { value: "DMRCL", label: "DMRCL" },
        { value: "EPIL", label: "EPIL" },
        { value: "HRSI&IDCL", label: "HRSI&IDCL" },
        { value: "H&UDCL", label: "H&UDCL" },
        { value: "J&KRRDA", label: "J&KRRDA" },
        { value: "MHSIDC", label: "MHSIDC" },
        { value: "MHMRCL", label: "MHMRCL" },
        { value: "RJSRD&CCL", label: "RJSRD&CCL" },
        { value: "KARDCL", label: "KARDCL" },
        { value: "TNRDL", label: "TNRDL" },
        { value: "APRDC", label: "APRDC" },
        { value: "PBIDB", label: "PBIDB" },
        { value: "R&BDT", label: "R&BDT" },
        { value: "RCDJ", label: "RCDJ" },
        { value: "JHSRDC", label: "JHSRDC" },
        { value: "HPPWD", label: "HPPWD" },
        { value: "UKPWD", label: "UKPWD" },
        { value: "DSI&IDC", label: "DSI&IDC" },
        { value: "GOAPWD", label: "GOAPWD" },
        { value: "HRRIDC", label: "HRRIDC" },
        { value: "RIDFOD", label: "RIDFOD" },
        { value: "RJSID&IC", label: "RJSID&IC" },
        { value: "KLRFB", label: "KLRFB" },
        { value: "RSHA", label: "RSHA" },
        { value: "BIDA", label: "BIDA" },
        { value: "MIDFC", label: "MIDFC" },
        { value: "JKSCC", label: "JKSCC" },
        { value: "SOI", label: "SOI" },
        { value: "JNPT", label: "JNPT" },
        { value: "BMRCL", label: "BMRCL" },
        { value: "KRCL", label: "KRCL" },
        { value: "OBCCL", label: "OBCCL" },
        { value: "NHSRCL", label: "NHSRCL" },
        { value: "Other", label: "Other" },
    ]
    const costTypeList = [
        { value: "crore", label: "In Crore" },
        { value: "lakh", label: "In Lakh" },
        { value: "thousand", label: "In Thousand" },
        { value: "crore_lakh", label: "In Crore & Lakh" },
        { value: "lakh_thousand", label: "In Lakh & Thousand" },
        { value: "crore_lakh_thousand", label: "In Crore, Lakh & Thousand" },

    ]

    const costTypesOptions = costTypeList
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((i) => ({
            value: i.value,
            label: i.label,
        }));

    const [department, setDepartment] = useState("null");

    const departmentOption = departmentListRailways
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((i) => ({
            value: i.value,
            label: i.label,
        }));
    const departmentHighwayOption = departListHighway
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((i) => ({
            value: i.value,
            label: i.label,
        }));


    const handleDepartmentChange = (selectedOption) => {
        if (!selectedOption) {
            setDepartment("null");
        } else {
            setDepartment(selectedOption.value);
        }
    };
    const handleCostTypeChange = (selectedOption) => {
        if (!selectedOption) {
            setCostType("null");
        } else {
            setCostType(selectedOption.value);
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.CostType;
                return updated;
            });
        }
    };

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            department: department
        }))
    }, [department])

    // *************************************WorktypeData Details **************************************//

    const [workTypeList, setWorktypeList] = useState([]);

    const getData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/dpr/worktype/`);
            setWorktypeList(response.data)
        } catch (error) {
            console.error(error);

        }
    };

    useEffect(() => {
        if (show === true) {
            getData();
        }
    }, [show])

    const [formData2, setFormData2] = useState({
        name: "",
        division: "",
    });

    const [error2, setErrors2] = useState({

    })

    const [worktype, setWorktype] = useState("null");

    const validateform2 = () => {
        const newErrors = {};
        const requiredFields = ["name",];

        requiredFields.forEach((field) => {
            if (!formData2[field]?.trim()) {
                newErrors[field] = `This field is required!`;
            }
        });

        setErrors2(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setFormData2((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors2((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });
    };


    const workTypeOption = workTypeList
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((i) => ({
            value: i.id,
            label: i.name,
        }));
    const extendedworkTypeOption = [
        ...workTypeOption,
        { label: "Other", value: "other" },
    ];

    const handleWorkTypeOption = (selectedOption) => {
        if (!selectedOption) {
            setWorktype("null");
        } else {
            setWorktype(selectedOption.value);

        }
    };

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            work_type_id: worktype
        }))
    }, [worktype]);

    useEffect(() => {
        setFormData2((prev) => ({
            ...prev,
            division: formData.division
        }))
    }, [formData.division])

    const handleFormSubmit2 = async (e) => {
        e.preventDefault();

        if (validateform2()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const res = await axios.post(`${BASE_URL}/dpr/worktype/`, formData2, AUTH());

                if (res.status === 201 || res.status === 200) {
                    toast.success("Worktype added successfully!");
                    setFormData2({
                        name: '',
                        division: ''
                    });
                    getData();
                    const updatedformdata = {
                        ...formData,
                        work_type_id: res.data.id
                    }

                    setFormData(updatedformdata);
                }
            } catch (err) {
                console.error("Error adding Worktype:", err);
                if (err.response?.data) {
                    toast.error(`Failed to add Worktype: ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to add Worktype");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };
    // *************************************End ofWorktypeData Details **************************************//


    // ************************************* Sector Details **************************************//


    const [sectorList, setSectorList] = useState([]);

    const getData2 = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/dpr/subconsultant/`);
            setSectorList(response.data)
        } catch (error) {
            console.error(error);

        }
    };

    useEffect(() => {
        if (show === true) {

            getData2();
        }
    }, [show])
    const [formData3, setFormData3] = useState({
        name: "",
        division: "",
    });

    const [error3, setErrors3] = useState({})

    const [sector, setsector] = useState("a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7");
    const [sectorName, setsectorName] = useState("Railway");

    const validateform3 = () => {
        const newErrors = {};
        const requiredFields = ["name"];

        requiredFields.forEach((field) => {
            if (!formData3[field]?.trim()) {
                newErrors[field] = `This field is required!`;
            }
        });

        setErrors3(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange3 = (e) => {
        const { name, value } = e.target;
        setFormData3((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors3((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });
    };


    const sectorOption = sectorList
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((i) => ({
            value: i.id,
            label: i.name,
        }));
    const extendedSectorOption = [
        ...sectorOption,
        { label: "Other", value: "other" },
    ];

    const handleSectorOption = (selectedOption) => {
        if (!selectedOption) {
            setsector("a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7");
            setsectorName("Railway");
        } else {
            setsector("a00ab7e2-34cd-43e3-96f0-f9ee15caa6e7");
            setsectorName("Railway")
        }
    };

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            sector: sector
        }))
    }, [sector]);

    useEffect(() => {
        setFormData3((prev) => ({
            ...prev,
            division: formData.division
        }))
    }, [formData.division])

    const handleFormSubmit3 = async (e) => {
        e.preventDefault();

        if (validateform3()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {

                const res = await axios.post(`${BASE_URL}/dpr/subconsultant/`, formData3, AUTH());

                if (res.status === 201 || res.status === 200) {
                    toast.success("Sector added successfully!");
                    setFormData3({
                        name: '',
                        division: ''
                    });
                    getData2();

                    const updatedformdata = {
                        ...formData,
                        sector: res.data.id
                    }

                    setFormData(updatedformdata);
                }
            } catch (err) {
                console.error("Error adding Sector:", err);
                if (err.response?.data) {
                    toast.error(`Failed to add Sector: ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to add Sector");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };


    // *************************************End of Sector Details **************************************//
    // *************************************starting of Workstages Details **************************************//

    const [workStagesList, setworkStagesList] = useState([]);

    const getData3 = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/dpr/workstats/`);
            setworkStagesList(response.data)
        } catch (error) {
            console.error(error);

        }
    };

    useEffect(() => {
        if (show === true) {

            getData3();
        }
    }, [show])

    const [formData4, setFormData4] = useState({
        name: "",
        percentage: "",
        workstage_inputtype: "",
        stage: [],
        rank: "",
        normal_input: [],
        submission_data: [],
    });

    const [error4, setErrors4] = useState({})


    const validateform4 = () => {
        const newErrors = {};
        const requiredFields = ["name", "workstage_inputtype"];

        requiredFields.forEach((field) => {
            if (!formData4[field]?.trim()) {
                newErrors[field] = `This field is required!`;
            }
        });



        setErrors4(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange4 = (e) => {
        const { name, value } = e.target;
        setFormData4((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors4((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });

    };


    const WorkStatOption = workStagesList
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((i) => ({
            value: i.id,
            label: i.name,
        }));
    const extendedWorkStatOption = [
        ...WorkStatOption,
        { label: "Other", value: "other" },
    ];






    const handleFormSubmit4 = async (e) => {
        e.preventDefault();

        if (validateform4()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            try {
                const res = await axios.post(`${BASE_URL}/dpr/workstats/`, formData4, AUTH());

                if (res.status === 201 || res.status === 200) {
                    toast.success("Workstage added successfully!");

                    setFormData4({
                        name: '',
                        division: ''
                    });

                    getData3();

                    const cleanedWorkstages = formData.workstages.filter(
                        (w) => w !== "other"
                    );

                    const updatedFormData = {
                        ...formData,
                        workstages: [...cleanedWorkstages, res.data.id]
                    };

                    setFormData(updatedFormData);
                }
            } catch (err) {
                console.error("Error adding Workstage:", err);
                if (err.response?.data) {
                    toast.error(`Failed to add Workstage: ${JSON.stringify(err.response.data)}`);
                } else {
                    toast.error("Failed to add Workstage");
                }
            } finally {
                toast.dismiss(loadingToastId);
            }
        }

    };

    const [inputValue, setinputValue] = useState("");

    const inputTypeList = [
        { value: "Submission", label: "Submission" },
        { value: "Stage", label: "Stage" },
        { value: "Input", label: "Input" },
    ]

    const inputOptions = inputTypeList
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((i) => ({
            value: i.value,
            label: i.label,
        }));


    const handleInputOptions = (selectedOption) => {
        if (!selectedOption) {
            setinputValue("");
        } else {
            setinputValue(selectedOption.value);
        }
    };


    useEffect(() => {
        setFormData4((prev) => ({
            ...prev,
            workstage_inputtype: inputValue
        }))
    }, [inputValue])

    // *************************************End of Workstages Details **************************************//

    const [subCompanyData, setsubCompanyData] = useState("null");


    const subCompanyOptions = subCompany
        ?.sort((a, b) =>
            a?.division_name?.localeCompare(b.division_name, "en", {
                ignorePunctuation: true,
            })
        )
        .map((i) => ({
            value: i.id,
            label: i.division_name,
        }));


    const handleSubCompanyInputOptions = (selectedOption) => {
        if (!selectedOption) {
            setsubCompanyData("null");
        } else {
            setsubCompanyData(selectedOption.value);
        }
    };

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            division: subCompanyData
        }))
    }, [subCompanyData])


    // **************************************End of division code***************************//

    const companyOptions = company
        ?.sort((a, b) =>
            a?.company_name?.localeCompare(b.company_name, "en", {
                ignorePunctuation: true,
            })
        )
        .map((i) => ({
            value: i.id,
            label: i.company_name,
        }));


    const handleCompanyInputOptions = (selectedOption) => {
        if (!selectedOption) {
            setCompanyData("null");
        } else {
            setCompanyData(selectedOption.value);
        }
    };

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            subcompany: companyData
        }))
    }, [companyData])

    useEffect(() => {
        if (formData.subcompany === "null") {
            setFormData((prev) => ({
                ...prev,
                division: "null"
            }));
            setSubCompany([]);
            setsubCompanyData("null");
        }
    }, [formData.subcompany]);

    const [removeSectorInputField, setRemoveSectorInputField] = useState(false);
    const [removeWorkTypeInputField, setRemoveWorkTypeInputField] = useState(false);
    const handleRemoveInput = () => {
        setRemoveSectorInputField(true);
    }
    const handleRemoveWorktypeInput = () => {
        setRemoveWorkTypeInputField(true);
    }

    useEffect(() => {
        if (removeSectorInputField === true) {
            setFormData((prev) => ({
                ...prev,
                sector: "null",
            }));
            setsector("null")
        }

    }, [removeSectorInputField])
    useEffect(() => {
        if (removeWorkTypeInputField === true) {
            setFormData((prev) => ({
                ...prev,
                work_type_id: "null",
            }));
            setWorktype("null")
        }

    }, [removeWorkTypeInputField])
    useEffect(() => {
        if (formData.sector === "other") {
            setRemoveSectorInputField(false);
        }
    }, [formData.sector])
    useEffect(() => {
        if (formData.sector === "other") {
            setRemoveSectorInputField(false);
        }
    }, [formData.sector])
    useEffect(() => {
        if (formData.work_type_id === "other") {
            setRemoveWorkTypeInputField(false);
        }
    }, [formData.work_type_id])








    const handleCroreInputChange = (e) => {
        const value = e.target.value;

        if (/^\d{0,3}$/.test(value)) {
            setCroreInput(value);
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.croreInput;
                return updated;
            });
        }
    };

    const handleLakhInputChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,2}$/.test(value)) {
            setLakhInput(value);

            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.lakhInput;
                return updated;
            });
        }
    };

    const handleThousandInputChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,5}$/.test(value)) {
            setThousandInput(value);

            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.thousandInput;
                return updated;
            });
        }


    };


    useEffect(() => {
        setCroreInput("");
        setLakhInput("");
        setThousandInput("")
        setFormData((prev) => ({
            ...prev,
            project_post: "",
            basic_value: "",
            total_amount: Number(prev.gst_amount || 0),
        }))
    }, [CostType])




    useEffect(() => {
        if (CostType === "crore_lakh_thousand" && croreInput !== "" && lakhInput !== "" && thousandInput !== "") {
            const totalVal = croreInput + lakhInput + thousandInput;
            setFormData((prev) => ({
                ...prev,
                project_post: totalVal,
basic_value: totalVal,
total_amount:
    Number(totalVal || 0) +
    Number(prev.gst_amount || 0),
            }))
        }
        else if (CostType === "crore_lakh" && croreInput !== "" && lakhInput !== "") {
            const totalVal = croreInput + lakhInput;
            setFormData((prev) => ({
                ...prev,
                project_post: totalVal,
basic_value: totalVal,
total_amount:
    Number(totalVal || 0) +
    Number(prev.gst_amount || 0),
            }))
        }
        else if (CostType === "lakh_thousand" && lakhInput !== "" && thousandInput !== "") {
            const totalVal = lakhInput + thousandInput;
            setFormData((prev) => ({
                ...prev,
                project_post: totalVal,
basic_value: totalVal,
total_amount:
    Number(totalVal || 0) +
    Number(prev.gst_amount || 0),
            }))
        }
        else if (CostType === "thousand" && thousandInput !== "") {
            const totalVal = thousandInput;
            setFormData((prev) => ({
                ...prev,
                project_post: totalVal,
basic_value: totalVal,
total_amount:
    Number(totalVal || 0) +
    Number(prev.gst_amount || 0),
            }))
        }
        else if (CostType === "lakh" && lakhInput !== "") {
            const totalVal = lakhInput;
            setFormData((prev) => ({
                ...prev,
                project_post: totalVal,
basic_value: totalVal,
total_amount:
    Number(totalVal || 0) +
    Number(prev.gst_amount || 0),
            }))
        }
        else if (CostType === "crore" && croreInput !== "") {
            const totalVal = croreInput;
            setFormData((prev) => ({
                ...prev,
                project_post: totalVal,
basic_value: totalVal,
total_amount:
    Number(totalVal || 0) +
    Number(prev.gst_amount || 0),
            }))
        }
    }, [CostType, croreInput, lakhInput, thousandInput])




    return (
        <>
            {useFor === "dashboard" ?
                <motion.button
                    className="btn-primary"
                    title="Add Data"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleShow}

                >
                    <Plus size={18} />
                    Project Details
                </motion.button> :
                <button
                    title="Add Data"
                    className="upload-svg"
                    onClick={handleShow}
                >
                    <AddwithWhiteCircle /> Railway Project
                </button>

            }


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave-document"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>Add Railway Project</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div className="parent-div">
                        <div className="form-flex-wrap">
                            <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                <div title="Project code" className="flex-column">
                                    <label
                                        htmlFor="pr_code"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Project Code<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="pr_code"
                                        name="pr_code"
                                        placeholder="Project code"
                                        onChange={handleInputChange}
                                        value={formData.pr_code}
                                        style={{ width: "15vw" }}
                                        className={`form-input-date ${errors.pr_code ? "input-error" : ""}`}

                                    />
                                    {errors.pr_code && (
                                        <span className="error-message font-size-text">
                                            {errors.pr_code}
                                        </span>
                                    )}
                                </div>
                                <div title="Project Short Name" className="flex-column">
                                    <label
                                        htmlFor="project_short_name"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Project Short Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="project_short_name"
                                        name="project_short_name"
                                        placeholder="Project Short Name"
                                        onChange={handleInputChange}
                                        style={{ width: "15vw" }}
                                        value={formData.project_short_name}
                                        className={`form-input-date ${errors.project_short_name ? "input-error" : ""}`}

                                    />
                                    {errors.project_short_name && (
                                        <span className="error-message font-size-text">
                                            {errors.project_short_name}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Company Name <span className="required">*</span>
                                    </label>

                                    {company.length === 0 ? (
                                        <div className="form-loader " style={{ width: '15vw', }}>
                                            <div className="bar-loader " style={{ width: '15vw' }}></div>
                                        </div>
                                    ) : (
                                        <>
                                            <Select
                                                options={companyOptions}
                                                onChange={handleCompanyInputOptions}
                                                value={
                                                    formData.subcompany === null ||
                                                        formData.subcompany === "null" ||
                                                        formData.subcompany === undefined
                                                        ? null
                                                        : companyOptions.find((option) => option.value === formData.subcompany)
                                                }
                                                placeholder="Select Company Name"
                                                isSearchable
                                                isClearable
                                                noOptionsMessage={() => "No other options"}
                                                styles={CSSForSelect15VW}
                                            />


                                            {errors.subcompany && (
                                                <span className="error-message font-size-text">
                                                    {errors.subcompany}
                                                </span>
                                            )}
                                        </>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                    >
                                        SubCompany  <span className="required"> *</span>
                                    </label>



                                    <Select
                                        options={subCompanyOptions}
                                        onChange={handleSubCompanyInputOptions}
                                        value={
                                            formData.division === null ||
                                                formData.division === "null" ||
                                                formData.division === undefined
                                                ? null
                                                : subCompanyOptions.find((option) => option.value === formData.division)
                                        }
                                        placeholder="Select Sub Company"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => companyData === "null" ? "(Select Company First)" : "No other options"}
                                        styles={CSSForSelect15VW}
                                    />


                                    {errors.division && (
                                        <span className="error-message font-size-text">
                                            {errors.division}
                                        </span>
                                    )}

                                </div>
                            </div>


                            <div title="Project name" style={{ width: "98.5%" }} className="flex-column">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels font-weight500 font-size-subheading"
                                >
                                    Project Name<span className="required">*</span>
                                </label>
                                <textarea
                                    type="text"
                                    id="project_name"
                                    name="project_name"
                                    placeholder="Project Name"
                                    onChange={handleInputChange}
                                    value={formData.project_name}
                                    style={{ width: "100%" }}
                                    className={`form-input form-input-textarea  ${errors.project_name ? "input-error" : ""}`}
                                />
                                {errors.project_name && (
                                    <span className="error-message font-size-text">
                                        {errors.project_name}
                                    </span>
                                )}
                            </div>
                            <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                {
                                    formData.sector !== "other" &&
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Sector <span className="required">(Read-Only)</span>
                                        </label>


                                        <>
                                            <Select
                                                options={extendedSectorOption}
                                                onChange={handleSectorOption}
                                                value={
                                                    formData.sector === "null" ||
                                                        formData.sector === undefined
                                                        ? "null"
                                                        : extendedSectorOption.find(
                                                            (option) =>
                                                                option.value === formData.sector
                                                        )
                                                }
                                                isDisabled
                                                placeholder="Select Sector"
                                                isSearchable
                                                isClearable
                                                noOptionsMessage={() => "No other options"}
                                                styles={CSSForSelect15VW}
                                            />




                                            {errors.sector && (
                                                <span className="error-message font-size-text">
                                                    {errors.sector}
                                                </span>
                                            )}
                                        </>

                                    </div>
                                }

                                {
                                    formData.sector === "other" &&
                                    <>
                                        <div title="Sector Name" className="flex-column">
                                            <div className='flex-row justify-between'>
                                                <label
                                                    htmlFor="name"
                                                    className="form-labels font-weight500 font-size-subheading"
                                                >
                                                    Sector Name<span className="required">*</span>
                                                </label>
                                                <div className='flex-row'>

                                                    <button
                                                        onClick={handleRemoveInput}
                                                        style={{
                                                            height: "20px",
                                                            width: "20px",
                                                            borderRadius: "50%",
                                                            border: "2px solid red",
                                                            color: "red",
                                                            background: "white",
                                                            fontWeight: "400",
                                                            fontSize: "20px",
                                                            marginRight: "10px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                    <AddWithPlus onClick={handleFormSubmit3} title="Submit" />
                                                </div>
                                            </div>

                                            <input
                                                type="text"
                                                maxLength={100}
                                                name="name"
                                                placeholder="Sector Name"
                                                onChange={handleInputChange3}
                                                value={formData3.name}
                                                style={{ width: "15vw" }}
                                                className={`form-input ${error3.name ? "input-error" : ""}`}

                                            />
                                            {error3.name && (
                                                <span className="error-message font-size-text">
                                                    {error3.name}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                }
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Department <span className="required">*</span>
                                    </label>


                                    <>
                                        <Select
                                            options={
                                                sectorName === "Highway"
                                                    ? departmentHighwayOption
                                                    : sectorName === "Railway"
                                                        ? departmentOption
                                                        : [{ label: "No Department found for this sector", value: "" }]
                                            }
                                            onChange={handleDepartmentChange}
                                            value={
                                                formData.department === null ||
                                                    formData.department === "null" ||
                                                    formData.department === undefined
                                                    ? null
                                                    : (sectorName === "Highway"
                                                        ? departmentHighwayOption
                                                        : departmentOption
                                                    ).find((option) => option.value === formData.department)
                                            }
                                            placeholder="Select Work Type"
                                            isSearchable
                                            isClearable
                                            noOptionsMessage={() => "No other options"}
                                            styles={CSSForSelect15VW}
                                        />





                                        {errors.department && (
                                            <span className="error-message font-size-text">
                                                {errors.department}
                                            </span>
                                        )}
                                    </>

                                </div>
                            </div>
                            <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                {formData.work_type_id !== "other" &&
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Work Type <span className="required">*</span>
                                        </label>


                                        <>
                                            <Select
                                                options={extendedworkTypeOption}
                                                onChange={handleWorkTypeOption}
                                                value={
                                                    formData.work_type_id === "null" ||
                                                        formData.work_type_id === undefined
                                                        ? "null"
                                                        : extendedworkTypeOption.find(
                                                            (option) =>
                                                                option.value === formData.work_type_id
                                                        )
                                                }
                                                placeholder="Select WorkType"
                                                isSearchable
                                                isClearable
                                                noOptionsMessage={() => "No other options"}
                                                styles={CSSForSelect15VW}
                                            />




                                            {errors.work_type_id && (
                                                <span className="error-message font-size-text">
                                                    {errors.work_type_id}
                                                </span>
                                            )}
                                        </>

                                    </div>
                                }

                                {
                                    formData.work_type_id === "other" &&
                                    <>
                                        <div title="Work Type Name" className="flex-column">
                                            <div className='flex-row justify-between'>
                                                <label
                                                    htmlFor="name"
                                                    className="form-labels font-weight500 font-size-subheading"
                                                >
                                                    Work Type Name<span className="required">*</span>
                                                </label>
                                                <div className='flex-row'>

                                                    <button
                                                        onClick={handleRemoveWorktypeInput}
                                                        style={{
                                                            height: "20px",
                                                            width: "20px",
                                                            borderRadius: "50%",
                                                            border: "2px solid red",
                                                            color: "red",
                                                            background: "white",
                                                            fontWeight: "400",
                                                            fontSize: "20px",
                                                            marginRight: "10px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                    <AddWithPlus onClick={handleFormSubmit2} title="Submit" />
                                                </div>
                                            </div>

                                            <input
                                                type="text"
                                                maxLength={100}
                                                name="name"
                                                placeholder="Work Type Name"
                                                onChange={handleInputChange2}
                                                style={{ width: "20vw" }}
                                                value={formData2.name}
                                                className={`form-input ${error2.name ? "input-error" : ""}`}

                                            />
                                            {error2.name && (
                                                <span className="error-message font-size-text">
                                                    {error2.name}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                }

                                <div title="Total Length" className="flex-column">
                                    <label
                                        htmlFor="total_length"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Total Length(in KM)<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        maxLength={100}
                                        id="total_length"
                                        name="total_length"
                                        placeholder="Total Length"
                                        style={{ width: "15vw" }}
                                        onChange={handleInputChange}
                                        value={formData.total_length}
                                        className={`form-input ${errors.total_length ? "input-error" : ""}`}

                                    />
                                    {errors.total_length && (
                                        <span className="error-message font-size-text">
                                            {errors.total_length}
                                        </span>
                                    )}
                                </div>
                            </div>


                            <div className='flex-row justify-between' style={{ width: "35vw" }}>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Cost Type <span className="required">*</span>
                                    </label>


                                    <>
                                        <Select
                                            options={costTypesOptions}
                                            onChange={handleCostTypeChange}
                                            value={
                                                CostType === "null" ||
                                                    CostType === undefined
                                                    ? "null"
                                                    : costTypesOptions.find(
                                                        (option) =>
                                                            option.value === CostType
                                                    )
                                            }
                                            placeholder="Select Cost Type"
                                            isSearchable
                                            isClearable
                                            noOptionsMessage={() => "No other options"}
                                            styles={CostType === "null" || CostType === "lakh_thousand" || CostType === "crore_lakh" ? CSSForSelect : CSSForSelect15VW}
                                        />




                                        {errors.CostType && (
                                            <span className="error-message font-size-text">
                                                {errors.CostType}
                                            </span>
                                        )}
                                    </>

                                </div>
                                {
                                    CostType === "crore_lakh_thousand" ?
                                        <>
                                            <div title="Project Cost" className="flex-column">
                                                <label
                                                    htmlFor="croreInput"
                                                    className="form-labels font-weight500 font-size-subheading"
                                                >
                                                    Project Cost<span className="required">(in Cr)*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    maxLength={100}
                                                    id="croreInput"
                                                    name="croreInput"
                                                    placeholder="In Crores"
                                                    style={{ width: "15vw" }}
                                                    onChange={handleCroreInputChange}
                                                    value={croreInput}
                                                    className={`form-input ${errors.croreInput ? "input-error" : ""}`}

                                                />
                                                {errors.croreInput && (
                                                    <span className="error-message font-size-text">
                                                        {errors.croreInput}
                                                    </span>
                                                )}
                                            </div>

                                        </> :


                                        CostType === "crore" ? <>
                                            <div title="Project Cost" className="flex-column">
                                                <label
                                                    htmlFor="croreInput"
                                                    className="form-labels font-weight500 font-size-subheading"
                                                >
                                                    Project Cost<span className="required">(in Cr)*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    maxLength={3}
                                                    id="croreInput"
                                                    name="croreInput"
                                                    placeholder="In Crores"
                                                    style={{ width: "15vw" }}
                                                    onChange={handleCroreInputChange}
                                                    value={croreInput}
                                                    onBlur={() => {
                                                        if (CostType === "crore" && croreInput) {
                                                            setCroreInput(prev => {
                                                                if (prev.length <= 3) {
                                                                    return prev + "0000000"; // add 3 zeros
                                                                }
                                                                if (prev.length < 5) {
                                                                    return prev.padEnd(5, "0"); // pad to 5 digits
                                                                }
                                                                return prev;
                                                            });
                                                        }
                                                    }}
                                                    className={`form-input ${errors.croreInput ? "input-error" : ""}`}

                                                />
                                                {errors.croreInput && (
                                                    <span className="error-message font-size-text">
                                                        {errors.croreInput}
                                                    </span>
                                                )}
                                            </div>

                                        </> : CostType === "lakh" ? <>

                                            <div title="Project Cost" className="flex-column">
                                                <label
                                                    htmlFor="lakhInput"
                                                    className="form-labels font-weight500 font-size-subheading"
                                                >
                                                    Project Cost<span className="required">(in Lakh)*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    maxLength={100}
                                                    id="lakhInput"
                                                    name="lakhInput"
                                                    placeholder="In Lakhs"
                                                    style={{ width: "15vw" }}
                                                    onChange={handleLakhInputChange}
                                                    value={lakhInput}
                                                    onBlur={() => {
                                                        if (CostType === "lakh" && lakhInput) {
                                                            setLakhInput(prev => {
                                                                if (prev.length <= 2) {
                                                                    return prev + "00000"; // add 3 zeros
                                                                }
                                                                if (prev.length < 5) {
                                                                    return prev.padEnd(5, "0"); // pad to 5 digits
                                                                }
                                                                return prev;
                                                            });
                                                        }
                                                    }}
                                                    className={`form-input ${errors.lakhInput ? "input-error" : ""}`}

                                                />
                                                {errors.lakhInput && (
                                                    <span className="error-message font-size-text">
                                                        {errors.lakhInput}
                                                    </span>
                                                )}
                                            </div>
                                        </> : CostType === "thousand" &&
                                        <>
                                            <div title="Project Cost" className="flex-column">
                                                <label
                                                    htmlFor="thousandInput"
                                                    className="form-labels font-weight500 font-size-subheading"
                                                >
                                                    Project Cost<span className="required">(in Thousands)*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    maxLength={100}
                                                    id="thousandInput"
                                                    name="thousandInput"
                                                    placeholder="In Thousands"
                                                    style={{ width: "15vw" }}
                                                    onChange={handleThousandInputChange}
                                                    value={thousandInput}
                                                    onBlur={() => {
                                                        if (CostType === "thousand" && thousandInput) {
                                                            setThousandInput(prev => {
                                                                if (prev.length <= 2) {
                                                                    return prev + "000"; // add 3 zeros
                                                                }
                                                                if (prev.length < 5) {
                                                                    return prev.padEnd(5, "0"); // pad to 5 digits
                                                                }
                                                                return prev;
                                                            });
                                                        }
                                                    }}
                                                    className={`form-input ${errors.thousandInput ? "input-error" : ""}`}

                                                />
                                                {errors.thousandInput && (
                                                    <span className="error-message font-size-text">
                                                        {errors.thousandInput}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                }



                            </div>
                            {CostType === "crore_lakh" &&
                                <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                    <>
                                        <div title="Project Cost" className="flex-column">
                                            <label
                                                htmlFor="croreInput"
                                                className="form-labels font-weight500 font-size-subheading"
                                            >
                                                Project Cost<span className="required">(in Cr)*</span>
                                            </label>
                                            <input
                                                type="number"
                                                maxLength={100}
                                                id="croreInput"
                                                name="croreInput"
                                                placeholder="In Crores"
                                                style={{ width: "15vw" }}
                                                onChange={handleCroreInputChange}
                                                value={croreInput}
                                                className={`form-input ${errors.croreInput ? "input-error" : ""}`}

                                            />
                                            {errors.croreInput && (
                                                <span className="error-message font-size-text">
                                                    {errors.croreInput}
                                                </span>
                                            )}
                                        </div>
                                        <div title="Project Cost" className="flex-column">
                                            <label
                                                htmlFor="lakhInput"
                                                className="form-labels font-weight500 font-size-subheading"
                                            >
                                                Project Cost<span className="required">(in Lakh)*</span>
                                            </label>
                                            <input
                                                type="number"
                                                maxLength={100}
                                                id="lakhInput"
                                                name="lakhInput"
                                                placeholder="In Lakhs"
                                                style={{ width: "15vw" }}
                                                onChange={handleLakhInputChange}
                                                onBlur={() => {
                                                    if (CostType === "crore_lakh" && lakhInput) {
                                                        setLakhInput(prev => {
                                                            if (prev.length === 1) {
                                                                return "0" + prev + "00000"
                                                            }
                                                            if (prev.length <= 2) {
                                                                return prev + "00000"; // add 3 zeros
                                                            }
                                                            if (prev.length < 5) {
                                                                return prev.padEnd(5, "0"); // pad to 5 digits
                                                            }
                                                            return prev;
                                                        });
                                                    }
                                                }}
                                                value={lakhInput}
                                                className={`form-input ${errors.lakhInput ? "input-error" : ""}`}

                                            />
                                            {errors.lakhInput && (
                                                <span className="error-message font-size-text">
                                                    {errors.lakhInput}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                </div>
                            }

                            {(CostType === "crore_lakh_thousand" || CostType === "lakh_thousand") &&
                                <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                    <div title="Project Cost" className="flex-column">
                                        <label
                                            htmlFor="lakhInput"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Project Cost<span className="required">(in Lakh)*</span>
                                        </label>
                                        <input
                                            type="number"
                                            maxLength={100}
                                            id="lakhInput"
                                            name="lakhInput"
                                            placeholder="In Lakhs"
                                            style={{ width: "15vw" }}
                                            onChange={handleLakhInputChange}
                                            value={lakhInput}
                                            onBlur={() => {
                                                if (CostType === "crore_lakh_thousand" && lakhInput) {
                                                    setLakhInput(prev => {
                                                        if (prev.length === 1) {
                                                            return "0" + prev
                                                        }

                                                        return prev;
                                                    });
                                                }
                                            }}
                                            className={`form-input ${errors.lakhInput ? "input-error" : ""}`}

                                        />
                                        {errors.lakhInput && (
                                            <span className="error-message font-size-text">
                                                {errors.lakhInput}
                                            </span>
                                        )}
                                    </div>
                                    <div title="Project Cost" className="flex-column">
                                        <label
                                            htmlFor="thousandInput"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Project Cost<span className="required">(in Thousands)*</span>
                                        </label>
                                        <input
                                            type="number"
                                            maxLength={100}
                                            id="thousandInput"
                                            name="thousandInput"
                                            placeholder="In Thousands"
                                            style={{ width: "15vw" }}
                                            onChange={handleThousandInputChange}
                                            value={thousandInput}
                                            onBlur={() => {
                                                if (CostType === "crore_lakh_thousand" && thousandInput) {
                                                    setThousandInput(prev => {
                                                        if (prev.length === 1) {
                                                            return "0" + prev + "000"
                                                        }
                                                        if (prev.length <= 2) {
                                                            return prev + "000"; // add 3 zeros
                                                        }
                                                        if (prev.length < 5) {
                                                            return prev.padEnd(5, "0"); // pad to 5 digits
                                                        }
                                                        return prev;
                                                    });
                                                }
                                            }}
                                            className={`form-input ${errors.thousandInput ? "input-error" : ""}`}

                                        />
                                        {errors.thousandInput && (
                                            <span className="error-message font-size-text">
                                                {errors.thousandInput}
                                            </span>
                                        )}
                                    </div>

                                </div>
                            }
                            {/* GST and Total Amount */}
                            <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                <div title="GST Amount" className="flex-column">
                                    <label
                                        htmlFor="gst_amount"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        GST Amount (₹)
                                    </label>
                                    <input
                                        type="number"
                                        id="gst_amount"
                                        name="gst_amount"
                                        placeholder="GST Amount"
                                        style={{ width: "15vw" }}
                                        onChange={handleGstChange}
                                        value={formData.gst_amount ?? ""}
                                        className="form-input"
                                    />
                                </div>
                                <div title="Total Amount" className="flex-column">
                                    <label
                                        htmlFor="total_amount"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Total Amount (₹)<span className="required">(Read-Only)</span>
                                    </label>
                                    <input
                                        type="number"
                                        id="total_amount"
                                        style={{ width: "15vw" }}
                                        value={Number(formData.project_post || 0) + Number(formData.gst_amount || 0)}
                                        readOnly
                                        className="form-input"
                                    />
                                </div>
                            </div>
                            <div className='flex-row justify-between' style={{ width: "35vw" }}>
                                <div title="LOA Date" className="flex-column">
                                    <label
                                        htmlFor="loa_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        LOA Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        maxLength={100}
                                        id="loa_date"
                                        name="loa_date"
                                        placeholder="LOA Date"
                                        style={{ width: "15vw" }}
                                        onChange={handleInputChange}
                                        value={formData.loa_date}
                                        className={`form-input ${errors.loa_date ? "input-error" : ""}`}

                                    />
                                    {errors.loa_date && (
                                        <span className="error-message font-size-text">
                                            {errors.loa_date}
                                        </span>
                                    )}
                                </div>
                                <div title="Completion Date" className="flex-column">
                                    <label
                                        htmlFor="completion_date"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Completion Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        maxLength={100}
                                        id="completion_date"
                                        name="completion_date"
                                        placeholder="Completion Date"
                                        style={{ width: "15vw" }}
                                        onChange={handleInputChange}
                                        value={formData.completion_date}
                                        min={formData.loa_date}
                                        className={`form-input ${errors.completion_date ? "input-error" : ""}`}

                                    />
                                    {errors.completion_date && (
                                        <span className="error-message font-size-text">
                                            {errors.completion_date}
                                        </span>
                                    )}
                                </div>

                            </div>


                            <div title="WorkStat List" className="flex-column form-group-selectt">
                                <label htmlFor="workstages" className="form-labels  font-weight500    font-size-subheading">
                                    WorkStat List<span className="required">*</span>
                                </label>
                                <br />
                                <Select
                                    options={extendedWorkStatOption}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{ Option, MenuList }}
                                    placeholder="Select Name"
                                    onChange={(selected) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            workstages: selected ? selected.map((item) => item.value) : []
                                        }))
                                    }

                                    value={
                                        formData?.workstages?.map((val) =>
                                            extendedWorkStatOption.find((opt) => opt.value === val)
                                        ).filter(Boolean)
                                    }

                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '33.5vw',
                                            minHeight: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f7f8fa',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: '33.5vw',
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),

                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                                ? "#cfe2ff"
                                                : state.isFocused
                                                    ? "#cfe2ff"
                                                    : "white",

                                            color: "#4a4a4a",
                                            padding: "8px 12px",
                                            ":active": {
                                                backgroundColor: "#cfe2ff",
                                            }
                                        }),


                                    }}
                                />



                                {errors.workstages && <span className="error-message font-size-text ">{errors.workstages}</span>}
                            </div>

                            {formData.workstages.includes("other") && (
                                <>
                                    <div title="Work Stage Name" className="flex-column">
                                        <div className='flex-row justify-between'>
                                            <label
                                                htmlFor="name"
                                                className="form-labels font-weight500 font-size-subheading"
                                            >
                                                Work Stage Name<span className="required">*</span>
                                            </label>
                                            <AddWithPlus onClick={handleFormSubmit4} title="Add Work Stage" />
                                        </div>

                                        <input
                                            type="text"
                                            maxLength={100}
                                            name="name"
                                            placeholder="Work Stage Name"
                                            onChange={handleInputChange4}
                                            value={formData4.name}
                                            className={`form-input ${error2.name ? "input-error" : ""}`}

                                        />
                                        {error4.name && (
                                            <span className="error-message font-size-text">
                                                {error4.name}
                                            </span>
                                        )}
                                    </div>
                                    <div title="WorkStat Type" className="flex-column">
                                        <label
                                            htmlFor="workstage_inputtype"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            WorkStat Input Type<span className="required">*</span>
                                        </label>
                                        <>
                                            <Select
                                                options={inputOptions}
                                                onChange={handleInputOptions}
                                                value={
                                                    formData4.workstage_inputtype === null ||
                                                        formData4.workstage_inputtype === "null" ||
                                                        formData4.workstage_inputtype === undefined
                                                        ? null
                                                        : inputOptions.find((option) => option.value === formData4.workstage_inputtype)
                                                }
                                                placeholder="Select Input Type"
                                                isSearchable
                                                isClearable
                                                noOptionsMessage={() => "No other options"}
                                                styles={CSSForSelect}
                                            />





                                            {error4.workstage_inputtype && (
                                                <span className="error-message font-size-text">
                                                    {error4.workstage_inputtype}
                                                </span>
                                            )}
                                        </>



                                    </div>
                                </>

                            )}


                        </div>

                        <div className="button-models" style={{ width: '100%' }}>
                            <button
                                type="submit"
                                className="model-button font-weight500 model-button-submit"
                                onClick={handleFormSubmit}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};


export default AddRailwayProject;